import { render, staticRenderFns } from "./StandmansTable.vue?vue&type=template&id=45ed9ed3&scoped=true&"
import script from "./StandmansTable.vue?vue&type=script&lang=js&"
export * from "./StandmansTable.vue?vue&type=script&lang=js&"
import style0 from "./StandmansTable.vue?vue&type=style&index=0&id=45ed9ed3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ed9ed3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox,VSimpleCheckbox})
